import React from 'react';
interface Props {
  eyebrow: string;
  title: string;
  intro: string;
  image: string;
  imageAlt: string;
}
export function PageHeader({
  eyebrow,
  title,
  intro,
  image,
  imageAlt
}: Props) {
  return <section className="relative isolate overflow-hidden border-b border-hair" data-id="element-217" data-mp="3revqz7pbznxm">
      <img src={image} alt={imageAlt} className="absolute inset-0 h-full w-full object-cover" data-id="element-218" data-mp="3mfsl5l1j1dol" />
      <div className="absolute inset-0 bg-ink/85" aria-hidden="true" data-id="element-219" data-mp="2yporo6i1yubb" />
      <div className="relative mx-auto max-w-shell px-6 py-20 lg:py-24" data-id="element-220" data-mp="2ynu6qs6s7278">
        <p className="font-mono text-[11px] uppercase tracking-[0.26em] text-gold" data-id="element-221" data-mp="2tseu23kifcce">{eyebrow}</p>
        <h1 className="mt-5 max-w-3xl font-display text-4xl leading-[1.1] text-bone sm:text-5xl lg:text-6xl" data-id="element-222" data-mp="38gjepd34hxxt">
          {title}
        </h1>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-bone/75" data-id="element-223" data-mp="33n6tze1kebac">{intro}</p>
      </div>
    </section>;
}